import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/family_users/get_free_reduced_url
export const freeReducedUrl = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/family_users/get_free_reduced_url`, payload)
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
